import { skipToken } from '@reduxjs/toolkit/query';
import { CommanderAPI } from '../CommanderAPI';
import { useAppSelector } from '../../../../redux/store.model';
import { getMyWorkspaceSelector } from '../../../../redux/workspace/selectors/Workspace.selectors';
import { ITypeRequest } from '../../../../theme/ui/Dashboard/Dashboard.model';
import { M_SECONDS_POOLING_INTERVAL_DATA } from '../../../store/Store.constants';

interface IUseCommanderOfflineProps {
  groupId?: string;
  workspaceId?: string;
  typeRequest: ITypeRequest;
}
function useCommanderOfflineCount(props: IUseCommanderOfflineProps) {
  const { typeRequest, groupId, workspaceId } = props;

  const userDevicesConnectionStatusResponse =
    CommanderAPI.useGetDevicesConnectionStatusCountByUserQuery(undefined, {
      skip: typeRequest !== 'user',
      pollingInterval: M_SECONDS_POOLING_INTERVAL_DATA,
    });

  const groupDevicesConnectionStatusResponse =
    CommanderAPI.useGetDevicesConnectionStatusCountByGroupQuery(
      groupId ?? skipToken,
      {
        skip: typeRequest !== 'group',
        pollingInterval: M_SECONDS_POOLING_INTERVAL_DATA,
      }
    );

  const workspaceDevicesConnectionStatusResponse =
    CommanderAPI.useGetDevicesConnectionStatusCountByWorkspaceQuery(
      workspaceId ?? skipToken,
      {
        skip: typeRequest !== 'workspace',
        pollingInterval: M_SECONDS_POOLING_INTERVAL_DATA,
      }
    );
  const myWorkspace = useAppSelector(getMyWorkspaceSelector);

  const workspacesDevicesConnectionStatusResponse =
    CommanderAPI.useGetDevicesConnectionStatusCountByWorkspaceQuery(
      myWorkspace?.id ?? skipToken,
      {
        skip: typeRequest !== 'workspaces',
        pollingInterval: M_SECONDS_POOLING_INTERVAL_DATA,
      }
    );
  switch (typeRequest) {
    case 'user':
      return userDevicesConnectionStatusResponse;
    case 'group':
      return groupDevicesConnectionStatusResponse;
    case 'workspace':
      return workspaceDevicesConnectionStatusResponse;
    case 'workspaces':
      return workspacesDevicesConnectionStatusResponse;
    default:
      return userDevicesConnectionStatusResponse;
  }
}

export default useCommanderOfflineCount;
